/**
 * @desc sleep
 * @param {Number} timestamp 延时时长
 * @return {Promise<void>} await sleep(1000)
 */
export const sleep = timestamp =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, timestamp)
  })
